"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapToPageable = mapToPageable;
exports.mapToPageablePayload = mapToPageablePayload;
exports.mapErrorToString = mapErrorToString;
exports.mapError = mapError;

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

function mapToPageable(payload) {
  var pageable = payload.pageable,
      totalElements = payload.totalElements,
      totalPages = payload.totalPages;
  var newPageable = {
    page: pageable.pageNumber + 1,
    rowsPerPage: pageable.pageSize,
    rowsNumber: totalElements,
    totalPages: totalPages
  };
  return newPageable;
}

function mapToPageablePayload(json) {
  var newPayload = {
    data: json.content,
    pagination: mapToPageable(json)
  };
  return newPayload;
}

function mapErrorToString(error) {
  if (error.fields.length > 0) {
    return error.fields.map(function (item) {
      return item['description'];
    }).join('\n');
  }

  return error.message ? error.message : error;
}

function mapError(error) {
  if (error.response) {
    if (error.response.status === 404) {
      return Promise.reject("".concat(error.config.url, " no encontrado"));
    } else {
      return Promise.reject(mapErrorToString(error.response.data));
    }
  }
}